import { createSlice, Dispatch } from "@reduxjs/toolkit";
import { GetStateFn } from "../utils/dispatchUtils";

export const menuOptionsSliceName = "menu";
export type MenuOptionsState = {
  collapsed: boolean;
};

const persistedMenuOptions = localStorage.getItem(menuOptionsSliceName);
const persistedState = persistedMenuOptions ? JSON.parse(persistedMenuOptions) as MenuOptionsState : null;
const fallback: MenuOptionsState = {
  collapsed: true,
};
const initialState: MenuOptionsState = persistedState ?? fallback;

const menuOptionsSlice = createSlice({
  name: menuOptionsSliceName,
  initialState,
  reducers: {
    toggleMenuCollapsed(state: MenuOptionsState) {
      state.collapsed = !state.collapsed;
    },
  },
});

export type MenuOptionsRootState = { [menuOptionsSliceName]: MenuOptionsState };
export const selectMenuOptions = (state: MenuOptionsRootState) => state[menuOptionsSliceName];
export const toggleMenuCollapsed = () => (dispatch: Dispatch, getState: GetStateFn) => {
  dispatch(menuOptionsSlice.actions.toggleMenuCollapsed());
  localStorage.setItem(menuOptionsSliceName, JSON.stringify(
    selectMenuOptions(getState()),
  ));
};

export const menuOptionsReducer = menuOptionsSlice.reducer;
